import React, { useEffect, useState } from "react";
import { Image, Row, Col, Typography, Carousel } from "antd";
import "@pages/LandingPage/index.scss";

import Step1Img from "@assets/images/ldp/step1.png";
import Step2Img from "@assets/images/ldp/step2.png";
import Step3Img from "@assets/images/ldp/step3.png";
import Step4Img from "@assets/images/ldp/step4.png";
import ProductDefaultImage from "@assets/images/product-default.png";

import HomeHeader from "@components/HomeHeader";
import { DATE_TIME_FORMAT, PATHS } from "@config/constants";
import { useQuery } from "react-query";
import { getResultsProduct } from "dataLayer/product";
import moment from "moment";
import { useTranslation } from "react-i18next";
import EmptyData from "@components/EmptyData";
import { NextArrowCarousel, PrevArrowCarousel } from "./ArrowIcon/Arrow";
import {useDetectPhone, getUserQuery} from "../../dataLayer/user";
import {isDetected, isLoggedIn} from "@utils/cookie";
const { Link } = Typography;

const LandingPage = () => {
  // Request nhận diện SĐT
  const { mutate } = useDetectPhone();
  useEffect(() => {
    if (!isLoggedIn() && !isDetected()) {
      mutate();
    }
  }, [mutate]);

  const [width, setWidth] = useState(window.innerWidth);
  const { data: results } = useQuery(getResultsProduct());
  const resultTotal = results
    ?.filter((i) => i?.status !== 5)
    ?.slice(0, 12)?.length;

  const setting = {
    autoplay: true,
    slidesToShow: resultTotal >= 4 ? 4 : resultTotal,
    slidesToScroll: resultTotal >= 4 ? 4 : resultTotal,
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: resultTotal >= 3 ? 3 : resultTotal,
          slidesToScroll: resultTotal >= 3 ? 3 : resultTotal,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: resultTotal >= 2 ? 2 : resultTotal,
          slidesToScroll: resultTotal >= 2 ? 2 : resultTotal,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          dots: false,
          // arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          // nextArrow: <NextArrowCarousel/>,
          // prevArrow: <PrevArrowCarousel/>,
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots: false,
          // arrows: true,
          swipeToSlide: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          // nextArrow: <NextArrowCarousel/>,
          // prevArrow: <PrevArrowCarousel/>,
        },
      },
    ],
  };

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  const isWebOneColumn = width <= 1200;

  return (
    <div>
      <HomeHeader tabActive={1} />
      {isMobile ? (
        <RenderMobileHtml results={results} setting={setting} />
      ) : isWebOneColumn ? (
        <RenderWebOneColumnHtml results={results} setting={setting} />
      ) : (
        <RenderWebHtml results={results} setting={setting} />
      )}
    </div>
  );
};

const RenderWebHtml = ({ setting, results }) => {
  const { t } = useTranslation();
  const resultTotal = results
    ?.filter((i) => i?.status !== 5)
    ?.slice(0, 12)?.length;

  return (
    <div className="box">
      <div className="box-text">
        <div className="box-title">Cómo participar</div>
      </div>
      <Row className="box-item">
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              1. Elige la suscripción de tu preferencia. Antes de suscribirte,
              lee y acepta nuestros “Términos y Condiciones”.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              2. Regístrate e inicia sesión con tu número Bitel y contraseña de
              Mi Bitel.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 1</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step2Img} />
              </div>
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 2</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step1Img} />
              </div>
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              3. Dirígete a la sección ‘Haz tu oferta/puja aquí’ y escribe el
              valor de la puja.
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="item-desc">
              4. Escribe el valor{" "}
              <b style={{ color: "red", fontWeight: 700 }}>más bajo y único</b>{" "}
              que crees que alguien pagaría por este producto. Haz clic en “Haz
              tu oferta/puja aquí” y listo ¡Ya estás participando!
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <Link href={PATHS.BID_PAGE}>
                <div className="item-header">
                  <span>Paso 3</span>
                </div>
                <div className="item-content">
                  <Image preview={false} src={Step3Img} />
                </div>
              </Link>
            </div>
          </div>
        </Col>
        <Col xl={12} md={24}>
          <div className="item-wrapper">
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 4</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step4Img} />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div className="box-text">
        <div className="box-title">Subastas anteriores</div>
      </div>
      {resultTotal > 0 ? (
        <Carousel {...setting}>
          {results
            ?.filter((i) => i?.status !== 5)
            ?.slice(0, 12)
            ?.map((item) => {
              const itemImages = item?.product_image?.split(",");
              return (
                <Col span={24}>
                  <div className="item-wrapper">
                    <div className="guide-item results-item">
                      <h2 className="product-text">{item?.product_name}</h2>
                      <div className="content-wrapper">
                        <div className="content-wrapper-result-image">
                          {itemImages ? (
                            <Carousel autoplay>
                              {itemImages?.map((image) => {
                                return (
                                  <img
                                    src={image}
                                    className="result-image"
                                    alt="Product images"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = ProductDefaultImage;
                                    }}
                                  />
                                );
                              })}
                            </Carousel>
                          ) : (
                            <img
                              src={ProductDefaultImage}
                              className="result-image"
                              alt="Default product images"
                            />
                          )}
                        </div>
                        {/* <div className="content-wrapper-text">
                          <div className="content-wrapper-date">
                            <div>
                              {t("product.round_start")}{" "}
                              {moment(item?.start_time).format(
                                DATE_TIME_FORMAT
                              )}
                            </div>
                            {" ~ "}
                            <div>
                              {t("product.round_end")}{" "}
                              {moment(item?.end_time).format(DATE_TIME_FORMAT)}
                            </div>
                          </div>
                          <div className="content-wrapper-price">
                            <h2> {t("product.market_price")}</h2>
                            <span>
                              {t("currency_sign")} {item?.product_price}
                            </span>
                          </div>
                          <div className="content-wrapper-price">
                            <h2>{t("product.final_price")}</h2>
                            <span>
                              {t("currency_sign")} {item?.auction_price}
                            </span>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
        </Carousel>
      ) : (
        <EmptyData message={t("no_results")} />
      )}
    </div>
  );
};

const RenderWebOneColumnHtml = ({ setting, results }) => {
  const { t } = useTranslation();
  const resultTotal = results
    ?.filter((i) => i?.status !== 5)
    ?.slice(0, 12)?.length;

  return (
    <div className="box">
      <div className="box-text">
        <div className="box-title">Cómo participar</div>
      </div>
      <Carousel autoplay>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              1. Elige la suscripción de tu preferencia.  Antes de suscribirte,
              lee y acepta nuestros “Términos y Condiciones”.
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 1</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step2Img} />
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              2. Regístrate e inicia sesión con tu número Bitel y contraseña de
              Mi Bitel.
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 2</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step1Img} />
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              3. Dirígete a la sección ‘Haz tu oferta/puja aquí’ y escribe el
              valor de la puja.
            </div>
            <div className="guide-item">
              <Link href={PATHS.BID_PAGE}>
                <div className="item-header">
                  <span>Paso 3</span>
                </div>
                <div className="item-content">
                  <Image preview={false} src={Step3Img} />
                </div>
              </Link>
            </div>
          </div>
        </Col>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              4. Escribe el valor{" "}
              <b style={{ color: "red", fontWeight: 700 }}>más bajo y único</b>{" "}
              que crees que alguien pagaría por este producto. Haz clic en “Haz
              tu oferta/puja aquí” y listo ¡Ya estás participando!
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 4</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step4Img} />
              </div>
            </div>
          </div>
        </Col>
      </Carousel>
      <div className="box-text">
        <div className="box-title">Subastas anteriores</div>
      </div>
      {resultTotal > 0 ? (
        <Carousel {...setting}>
          {results
            ?.filter((i) => i?.status !== 5)
            ?.slice(0, 12)
            ?.map((item) => {
              const itemImages = item?.product_image?.split(",");
              return (
                <Col span={24}>
                  <div className="item-wrapper">
                    <div className="guide-item results-item">
                      <h2 className="product-text">{item?.product_name}</h2>
                      <div className="content-wrapper">
                        <div className="content-wrapper-result-image">
                          {itemImages ? (
                            <Carousel autoplay>
                              {itemImages?.map((image) => {
                                return (
                                  <img
                                    src={image}
                                    className="result-image"
                                    alt="Product images"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = ProductDefaultImage;
                                    }}
                                  />
                                );
                              })}
                            </Carousel>
                          ) : (
                            <img
                              src={ProductDefaultImage}
                              className="result-image"
                              alt="Default product images"
                            />
                          )}
                        </div>
                        {/* <div className="content-wrapper-text">
                          <div className="content-wrapper-date">
                            <div>
                              {t("product.round_start")}{" "}
                              {moment(item?.start_time).format(
                                DATE_TIME_FORMAT
                              )}
                            </div>
                            {" ~ "}
                            <div>
                              {t("product.round_end")}{" "}
                              {moment(item?.end_time).format(DATE_TIME_FORMAT)}
                            </div>
                          </div>
                          <div className="content-wrapper-price">
                            <h2> {t("product.market_price")}</h2>
                            <span>
                              {t("currency_sign")} {item?.product_price}
                            </span>
                          </div>
                          <div className="content-wrapper-price">
                            <h2>{t("product.final_price")}</h2>
                            <span>
                              {t("currency_sign")} {item?.auction_price}
                            </span>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
        </Carousel>
      ) : (
        <EmptyData message={t("no_results")} />
      )}
    </div>
  );
};

const RenderMobileHtml = ({ setting, results }) => {
  const { t } = useTranslation();
  const resultTotal = results
    ?.filter((i) => i?.status !== 5)
    ?.slice(0, 12)?.length;

  return (
    <div className="box">
      <div className="box-text">
        <div className="box-title">Cómo participar</div>
      </div>
      <Carousel autoplay>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              1. Elige la suscripción de tu preferencia.  Antes de suscribirte,
              lee y acepta nuestros “Términos y Condiciones”.
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 1</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step2Img} />
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              2. Regístrate e inicia sesión con tu número Bitel y contraseña de
              Mi Bitel.
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 2</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step1Img} />
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              3. Dirígete a la sección ‘Haz tu oferta/puja aquí’ y escribe el
              valor de la puja.
            </div>
            <div className="guide-item">
              <Link href={PATHS.BID_PAGE}>
                <div className="item-header">
                  <span>Paso 3</span>
                </div>
                <div className="item-content">
                  <Image preview={false} src={Step3Img} />
                </div>
              </Link>
            </div>
          </div>
        </Col>
        <Col>
          <div className="item-wrapper">
            <div className="item-desc">
              4. Escribe el valor{" "}
              <b style={{ color: "red", fontWeight: 700 }}>más bajo y único</b>{" "}
              que crees que alguien pagaría por este producto. Haz clic en “Haz
              tu oferta/puja aquí” y listo ¡Ya estás participando!
            </div>
            <div className="guide-item">
              <div className="item-header">
                <span>Paso 4</span>
              </div>
              <div className="item-content">
                <Image preview={false} src={Step4Img} />
              </div>
            </div>
          </div>
        </Col>
      </Carousel>
      <div className="box-text">
        <div className="box-title">Subastas anteriores</div>
      </div>
      {resultTotal > 0 ? (
        <Carousel {...setting}>
          {results
            ?.filter((i) => i?.status !== 5)
            ?.slice(0, 12)
            ?.map((item) => {
              const itemImages = item?.product_image?.split(",");
              return (
                <Col span={24}>
                  <div className="item-wrapper">
                    <div className="guide-item results-item">
                      <h2 className="product-text">{item?.product_name}</h2>
                      <div className="content-wrapper">
                        <div className="content-wrapper-result-image">
                          {itemImages ? (
                            <Carousel autoplay>
                              {itemImages?.map((image) => {
                                return (
                                  <img
                                    src={image}
                                    className="result-image"
                                    alt="Product images"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = ProductDefaultImage;
                                    }}
                                  />
                                );
                              })}
                            </Carousel>
                          ) : (
                            <img
                              src={ProductDefaultImage}
                              className="result-image"
                              alt="Default product images"
                            />
                          )}
                        </div>
                        {/* <div className="content-wrapper-text">
                          <div className="content-wrapper-date">
                            <div>
                              {t("product.round_start")}{" "}
                              {moment(item?.start_time).format(
                                DATE_TIME_FORMAT
                              )}
                            </div>
                            {" ~ "}
                            <div>
                              {t("product.round_end")}{" "}
                              {moment(item?.end_time).format(DATE_TIME_FORMAT)}
                            </div>
                          </div>
                          <div className="content-wrapper-price">
                            <h2> {t("product.market_price")}</h2>
                            <span>
                              {t("currency_sign")} {item?.product_price}
                            </span>
                          </div>
                          <div className="content-wrapper-price">
                            <h2>{t("product.final_price")}</h2>
                            <span>
                              {t("currency_sign")} {item?.auction_price}
                            </span>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
        </Carousel>
      ) : (
        <EmptyData message={t("no_results")} />
      )}
    </div>
  );
};

export default LandingPage;
